import { BaseEcomSdkEnumsObj } from "@payair/e-com-common-sdk";
import { GooglePayEventListenerEnumsObj } from "../../enums/GooglePayEventListenerEnum";
import EventReporterService from "./EventReporterService";
import { getAdditionalInfo } from "@payair/e-com-common-sdk/core/BaseEcomSdk";
/** @internal */
var EventReporter = /** @class */ (function () {
    function EventReporter() {
        var _this = this;
        this.initEventReporterService = function (pspName, transactionId, merchantId) {
            _this.eventReporterService = new EventReporterService(pspName);
            _this.transactionId = transactionId;
            _this.merchantId = merchantId;
        };
        this.sendEvent = function (eventType, additionalInfo, requestId) {
            var eventParams = {
                eventType: eventType,
                requestId: requestId,
                additionalInfo: additionalInfo,
            };
            _this.handleEvent(eventParams);
        };
    }
    EventReporter.prototype.handleEvent = function (eventParams) {
        var googlePayEvent = {
            clientTimestamp: Date.now(),
            sdk: BaseEcomSdkEnumsObj.PAYAIR_GOOGLE_PAY_SDK,
            eventType: eventParams.eventType,
            additionalInfo: getAdditionalInfo(eventParams.additionalInfo),
            requestId: eventParams.requestId,
            transactionId: this.transactionId ? this.transactionId : "",
            merchantId: this.merchantId ? this.merchantId : "",
        };
        if (this.eventReporterService) {
            this.eventReporterService.reportEvent(googlePayEvent);
        }
        window.dispatchEvent(new CustomEvent(GooglePayEventListenerEnumsObj.PAYAIR_GOOGLE_PAY_SDK_LISTENER, { detail: googlePayEvent }));
    };
    return EventReporter;
}());
export default EventReporter;
